module.exports = __webpack_public_path__ + "media/connectivity-hero.0f1d97d9.mp4";